var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JobRevisionHeader',{attrs:{"title":"reference_pictures","showTitle":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }